// 9fbef606107a605d69c0edbcd8029e5d
const getGrandTotal = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'grandTotal']) || 0;
};

const getAppliedGiftCards = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'appliedGiftCards']);
};

const getGiftCardsTotal = (state) => {
  return state.CartPageReducer.getIn(['orderDetails', 'giftCardsTotal']) || 0;
};

const getGiftCardErrors = (state) => {
  return state.Checkout.getIn(['values', 'giftCardError']);
};

const getShowAddGiftCard = (state) => {
  return state.Checkout.getIn(['values', 'showAddGiftCard']) || false;
};

const getAddGiftCardErrors = (state) => {
  return state.Checkout.getIn(['values', 'addGiftCardError']);
};

const getAddGiftCardResponse = (state) => {
  return state.Checkout.getIn(['values', 'addGiftCardResponse']);
};

const getIsLoading = (state) => {
  return state.Checkout.getIn(['uiFlags', 'isLoadingShippingMethods']);
};

const getIsUpdatingShipmentMethods = (state) => {
  return state.Checkout.getIn(['uiFlags', 'isUpdatingShipmentMethods']);
};

export default {
  getGrandTotal,
  getAppliedGiftCards,
  getGiftCardsTotal,
  getGiftCardErrors,
  getShowAddGiftCard,
  getAddGiftCardErrors,
  getAddGiftCardResponse,
  getIsLoading,
  getIsUpdatingShipmentMethods,
};
